
import React, { memo } from "react";
import { motion, useReducedMotion } from "motion/react";

const animationVariants = {
  fade: {
    hidden: { opacity: 0 },
    visible: { opacity: 1 },
  },
  fadeUp: {
    hidden: { opacity: 0, y: 16 },
    visible: { opacity: 1, y: 0 },
  },
  fadeDown: {
    hidden: { opacity: 0, y: -16 },
    visible: { opacity: 1, y: 0 },
  },
  fadeLeft: {
    hidden: { opacity: 0, x: 16 },
    visible: { opacity: 1, x: 0 },
  },
  fadeRight: {
    hidden: { opacity: 0, x: -16 },
    visible: { opacity: 1, x: 0 },
  },
  scale: {
    hidden: { opacity: 0, scale: 0.95 },
    visible: { opacity: 1, scale: 1 },
  },
  zoom: {
    hidden: { opacity: 0, scale: 0.85 },
    visible: { opacity: 1, scale: 1 },
  },
  none: {
    hidden: {},
    visible: {},
  },
};

const MotionWrapper = memo(
  ({
    children,
    variant = "fadeUp",
    duration = 0.4,
    delay = 0,
    className = "",
    ...props
  }) => {
    const reduceMotion = useReducedMotion();

    const selected =
      animationVariants[variant] || animationVariants.fadeUp;

    return (
      <motion.div
        className={className}
        initial={reduceMotion ? false : selected.hidden}
        animate={selected.visible}
        transition={{
          duration: reduceMotion ? 0 : duration,
          delay: reduceMotion ? 0 : delay,
          ease: "easeOut",
        }}
        {...props}
      >
        {children}
      </motion.div>
    );
  },
);

MotionWrapper.displayName = "MotionWrapper";

export default MotionWrapper;
